import React, { useState } from 'react';

const Life = ({ data: { title, hobbies } }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentHobbies = hobbies.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(hobbies.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="card-inner active">
      <div className="card-wrap">
        <div className="content blog">
          <div className="title">
            <span>{title}</span>
          </div>
          <div className="content-space noSpace resumeSection">
            <div className="row row-margin border-line-v">
              {currentHobbies.map((post, index) => (
                <div key={index} className="col-md-6 colSpace">
                  <div className="box-item" style={{ cursor: 'default' }}>
                    <div className="image">
                      <a href="#!" onClick={e => e.preventDefault()} style={{ cursor: 'default' }}>
                        <img src={post.image} alt={post.alt} />
                        <span className="info">
                          <i className="fa fa-file-text-o" aria-hidden="true"></i>
                        </span>
                      </a>
                    </div>
                    <div className="desc">
                      {/* <a target="_blank" href="#!" rel="noopener noreferrer">
                        <span className="date">{post.date}</span>
                      </a> */}
                      <a
                        href="#!"
                        className="name"
                        onClick={e => e.preventDefault()}
                        style={{ cursor: 'default' }}
                      >
                        {post.title}
                      </a>
                      <div className="text">
                        <p>{post.excerpt}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="pager">
                <nav className="navigation pagination">
                  <div className="nav-links">
                    {pageNumbers.map(number => (
                      <span
                        key={number}
                        className={`page-numbers ${currentPage === number ? 'current' : ''}`}
                        onClick={() => handlePageChange(number)}
                      >
                        {number}
                      </span>
                    ))}
                    {/* {currentPage < pageNumbers.length && (
                      <span
                        className="page-numbers next"
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        Next
                      </span>
                    )} */}
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Life;
